import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import BtnCellRenderer from "../../common/BtnCellRenderer";
import { useHistory } from "react-router-dom";
import { doctorActions, patientActions } from "../../../core/actions";
import { Alert } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions"; // 👈 Add this
import TextField from "@mui/material/TextField";
import { InputAdornment, IconButton, Typography } from "@mui/material"; // 👈 Add Typography here
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

function Package(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const customComparator = (valueA, valueB) => {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
  };
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });

  const [pagination, setPagination] = useState(true);
  const [paginationPageSize, setPaginationPageSize] = useState(14);
  const [columnDefs] = useState([
    {
      headerName: "Package Service Name ",
      field: "name",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      comparator: customComparator,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Package Name",
      field: "packagename",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      headerClass: "ag-header-left",
    },
    // {headerName: "Amount",field: "amount",sortable: true,filter: true,flex: 1,resizable: true,floatingFilter: true,headerClass: "ag-header-left",cellStyle: { textAlign: "right" },},
    // {headerName: "Doctor",field: "isDoctor",sortable: true,filter: true,flex: 1,resizable: true,floatingFilter: true,headerClass: "ag-header-left",},
    {
      headerName: "Updated Date",
      field: "udt",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      headerClass: "ag-header-left",
      valueFormatter: (params) => {
        if (!params.value) return "";
        const d = new Date(params.value);
        return d.toLocaleString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },

    {
      headerName: "Actions",
      field: "Actions",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      width: 150,
      cellRenderer: "BtnCellRenderer",
      headerClass: "ag-header-left",
    },
  ]);
  const [packageList, setPackageList] = useState();
  const [packageServiceList, setPackageServiceList] = useState();
  const [searchText, setSearchText] = useState("");
  const [confirmModal, setConfirmMOdal] = useState(false);
  const [pServiceRowData, setpServiceRowData] = useState({});
  const [status, setStatus] = useState(undefined);

  const clearSearch = (event) => {
    setSearchText("");
  };

  useEffect(() => {
    console.log("useeffect");
    dispatch(patientActions.setPageHeader("packageService"));
    getServices();
  }, []);

  const getServices = () => {
    let data = {};
    dispatch(
      doctorActions.getServiceList(data, (resCb) => {
        if (resCb && resCb.packageServiceList) {
          // setPackageList(resCb.packageList);
          console.log(resCb);
          setPackageServiceList(resCb.packageServiceList);
          setPackageList(resCb.packageServiceList);
          console.log("packagelist", packageList);
        }
      })
    );
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const addPackage = (event) => {
    props.history.push("/packageAdd");
  };

  const getAggriddata = (e) => {
    console.log("clicked package service is", e);
    if (e.colDef.field == "Actions") {
      setConfirmMOdal(!confirmModal);
      console.log("delete rowdata:", e.data);
      setTimeout(() => {
        setpServiceRowData(e.data);
      }, 1000);
    } else {
      history.push("/packageAdd", {
        rowData: e.data,
        label: "edit",
      });
    }
  };

  const handleInputChange = (event) => {
    const searchedValue = event.target.value;
    setSearchText(searchedValue);

    if (searchedValue.length > 2) {
      const lowerSearch = searchedValue.toLowerCase();
      const serviceList = packageServiceList.filter((item) =>
        item.name.toLowerCase().includes(lowerSearch)
      );
      setPackageList(serviceList);
    } else {
      setPackageList(packageServiceList);
    }
  };

  const toggle = (event) => {
    setConfirmMOdal(!confirmModal);
  };

  const handleSubmit = () => {
    var ServerResVal = ServerRes;
    console.log("selected pservice row data is:", pServiceRowData);
    dispatch(
      patientActions.deletePackageService(pServiceRowData.id, (resCb) => {
        if (resCb) {
          console.log("Response of delete package service Api", resCb);
          setStatus({ type: "success" });
          ServerResVal.success = "Service deleted Successfully";
          setServerRes({ ...ServerResVal });
          toggle(resCb);
          getServices();
          setTimeout(() => {
            closeAlert();
          }, 3000);
        }
      })
    );
  };

  return (
    <>
      {ServerRes.success && (
        <Alert severity="success">{ServerRes.success} </Alert>
      )}
      {ServerRes.error && <Alert severity="error">{ServerRes.error} </Alert>}
      {/* <h5 className="page-title my-2 mx-3">Doctors</h5> */}
      {/* {ServerRes.error && (
        // <Alert theme="danger" className="alert-div">{ServerRes.error}<span><i className="material-icons"  onClick={(event) => closeAlert(event)} style={{cursor:'pointer'}}>close</i></span></Alert>
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      {ServerRes.success && (
        //  <Alert theme="success" className="alert-div">{ServerRes.success}<span><i className="material-icons"  onClick={(event) => closeAlert(event)} style={{cursor:'pointer'}}>close</i></span></Alert>
        <Alert severity="success" className="alert-div">
          {ServerRes.success}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )} */}
      <div class="mainsection">
        <div className="listTitles">
          <Grid item xs={12} className="page-header mb-3 doctorList">
            <h5
              // subtitle="Dashboard"
              className="text-sm-left mb-0"
            >
              Services/Packages List
            </h5>
            <Button
              variant="contained"
              className="floatingbtn"
              onClick={(event) => addPackage(event)}
              style={{ textTransform: "none" }}
            >
              Add New
            </Button>
          </Grid>
        </div>
        <form
          className="main-navbar__search d-md-flex d-lg-flex"
          style={{ width: `98% !important` }}
        >
          <div className="input-group input-group-seamless">
            <div className="input-group-prepend mb-2">
              <span className="input-group-text">
                <i style={{ color: `#111b21` }} className="material-icons">
                  search
                </i>
              </span>
            </div>
            {/* <FormInput
              className="navbar-search mb-2 menu-search bg-white"
              placeholder="Search Package..."
              value={searchText}
              type="search"
              onChange={handleInputChange}
            /> */}
            <TextField
              className="navbar-search mb-2 menu-search bg-white custom-text"
              placeholder="Search Package..."
              autoFocus
              value={searchText}
              type="search"
              onChange={handleInputChange}
              InputProps={{
                style: {
                  paddingLeft: "15px",
                  height: "35px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }, // Adjust padding as needed
              }}
            />
          </div>
        </form>
        <div>
          <div className="p-0 preview">
            <div
              className="ag-theme-balham ag-style card rounded table mb-0 tcol"
              style={{ height: 500, width: `98%` }}
            >
              <AgGridReact
                frameworkComponents={{ BtnCellRenderer: BtnCellRenderer }}
                pagination={pagination}
                paginationPageSize={paginationPageSize}
                rowData={packageList}
                columnDefs={columnDefs}
                onCellClicked={(e) => {
                  console.log("event onCellclicked::", e);
                  const field = e.colDef.field;
                  const colIndex = e.columnApi
                    .getAllColumns()
                    ?.findIndex((col) => col.getColDef().field === field);

                  console.log("cell clicked ", field, colIndex);
                  getAggriddata(e);
                }}
                //   rowStyle={rowStyle}
              ></AgGridReact>
            </div>
          </div>
          {confirmModal && (
            <div>
              <Dialog
                open={confirmModal}
                onClose={toggle}
                aria-labelledby="confirm-dialog-title"
                fullWidth
                maxWidth="sm" // or "xs" for smaller
                scroll="paper"
                PaperProps={{
                  sx: {
                    borderRadius: 2,
                    margin: { xs: 1, sm: 2 }, // responsive margin
                    width: "100%",
                  },
                }}
              >
                <DialogTitle
                  id="confirm-dialog-title"
                  sx={{
                    py: 2,
                    px: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Confirm Operation
                  <IconButton
                    aria-label="close"
                    onClick={toggle}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                      ml: "auto",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, pb: 2 }}>
                  <Typography variant="body1" color="textSecondary">
                    This operation cannot be undone! Do you want to continue?
                  </Typography>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                  <Button
                    onClick={toggle}
                    variant="outlined"
                    color="inherit"
                    sx={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="error"
                    sx={{ textTransform: "none", ml: 1 }}
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default Package;
